import { useMemo, MouseEvent } from 'react';

import { t } from '@lingui/macro';

import Wizard from '@decisiv/ui-components/lib/components/Wizard';
import StepOne from './StepOne';

import AddAssetProvider, {
  useAddAssetContext,
} from './context/AddAssetContext';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import IdentifyingAssets from './IdentifyingAssets';
import AddingAssets from './AddingAssets';

export interface AddAssetModalProps {
  accountId?: string;
  onCancel: (event: MouseEvent<unknown> | KeyboardEvent) => void;
  depotId?: string;
}

function AddAssetModal() {
  const {
    stepOneProps,
    stepThreeProps,
    stepTwoProps,
    stepFourProps,
    wizardProps,
  } = useAddAssetContext();

  const steps = useMemo(
    () => [
      {
        title: t`Select`,
        content: <StepOne />,
        intermediateContent: <IdentifyingAssets />,
        hideBodyTitle: true,
        ...stepOneProps,
      },
      {
        title: t`Review`,
        content: <StepTwo />,
        hideBodyTitle: true,
        ...stepTwoProps,
      },
      {
        title: t`Add Unit #`,
        content: <StepThree />,
        intermediateContent: <AddingAssets />,
        hideBodyTitle: true,
        ...stepThreeProps,
      },
      {
        title: t`Summary`,
        content: <StepFour />,
        hideBodyTitle: true,
        ...stepFourProps,
      },
    ],
    [stepOneProps, stepTwoProps, stepThreeProps, stepFourProps],
  );

  return <Wizard visible title={t`Add Asset`} steps={steps} {...wizardProps} />;
}

export default function AddAssetModalWrapper(props: AddAssetModalProps) {
  return (
    <AddAssetProvider
      accountId={props.accountId}
      onClose={props.onCancel}
      depotId={props.depotId}
    >
      <AddAssetModal />
    </AddAssetProvider>
  );
}
